import {
  CONTEXT_NODE_TYPE,
  VIRTUAL_CUSTOMER_PARENT,
} from "common/Constants/contextNode.constants";

export function appendVirtualCustomerParentIfAllowed(
  parentOptionsById,
  allowedParentTypes,
  customerName
) {
  if (!allowedParentTypes.includes(CONTEXT_NODE_TYPE.CUSTOMER)) {
    return;
  }
  const hasCustomerCandidate = [...parentOptionsById.values()].some(
    (node) =>
      String(node?.nodeType ?? "").toLowerCase() === CONTEXT_NODE_TYPE.CUSTOMER
  );
  const virtualKey = String(VIRTUAL_CUSTOMER_PARENT.NODE_ID);
  if (hasCustomerCandidate || parentOptionsById.has(virtualKey)) {
    return;
  }
  const resolvedName =
    customerName != null && String(customerName).trim() !== ""
      ? String(customerName).trim()
      : VIRTUAL_CUSTOMER_PARENT.DEFAULT_LABEL;
  parentOptionsById.set(virtualKey, {
    nodeId: VIRTUAL_CUSTOMER_PARENT.NODE_ID,
    nodeName: resolvedName,
    nodeType: CONTEXT_NODE_TYPE.CUSTOMER,
    parentNodeId: null,
  });
}
